export default {"src":"/_next/static/media/PurpleFaDollarSign.8c7fcd0b.svg","height":24,"width":25};